(function () {
  if (window.__BSG__) return;
  window.__BSG__ = true;

  // Capture phase to beat theme hijackers
  document.addEventListener("click", function (e) {
    const openBtn = e.target.closest?.("[data-bsg-open]");
    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const root = openBtn.closest("[data-bsg]");
      if (!root) return;

      const overlay = root.querySelector("[data-bsg-overlay]");
      const img = root.querySelector("[data-bsg-img]");
      const title = root.querySelector("[data-bsg-title]");

      const src = openBtn.getAttribute("data-bsg-src");
      const label = openBtn.getAttribute("data-bsg-label") || "Size guide";

      if (img) img.src = src;
      if (img) img.alt = label;
      if (title) title.textContent = label;

      overlay?.classList.add("is-open");
      document.documentElement.style.overflow = "hidden";
      return;
    }

    const closeBtn = e.target.closest?.("[data-bsg-close]");
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const root = closeBtn.closest("[data-bsg]");
      if (!root) return;

      const overlay = root.querySelector("[data-bsg-overlay]");
      const img = root.querySelector("[data-bsg-img]");
      const title = root.querySelector("[data-bsg-title]");

      overlay?.classList.remove("is-open");
      if (img) img.src = "";
      if (title) title.textContent = "";
      document.documentElement.style.overflow = "";
      return;
    }

    // click outside card closes
    const overlay = e.target.closest?.("[data-bsg-overlay]");
    if (overlay && e.target === overlay) {
      const root = overlay.closest("[data-bsg]");
      const img = root?.querySelector("[data-bsg-img]");
      const title = root?.querySelector("[data-bsg-title]");

      overlay.classList.remove("is-open");
      if (img) img.src = "";
      if (title) title.textContent = "";
      document.documentElement.style.overflow = "";
    }
  }, true);

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    const openOverlay = document.querySelector(".bsg__overlay.is-open");
    if (!openOverlay) return;

    const root = openOverlay.closest("[data-bsg]");
    const img = root?.querySelector("[data-bsg-img]");
    const title = root?.querySelector("[data-bsg-title]");

    openOverlay.classList.remove("is-open");
    if (img) img.src = "";
    if (title) title.textContent = "";
    document.documentElement.style.overflow = "";
  });
})();